<template>
  <div class="icon-box">
    <HoverableIconBig
      v-for="(iconData, index) of iconDataList"
      @click="onClick(iconData.href)"
      :key="index"
      :iconDataSpan="{ iconClass: iconData.iconClass, label: iconData.label, href: '' }"
    ></HoverableIconBig>
  </div>
</template>

<script setup lang="ts">
import { HoverableIconBig } from 'de-zurich-ui-library'
import { navigate } from '@/utils/NavigationUtils'
import { usePoliciesStore } from '@/stores/policiesStore'

defineProps(['iconDataList'])

const onClick = (href: string) => {
  const policiesStore = usePoliciesStore()
  policiesStore.resetPreSelectedPolicyId()
  navigate(href)
}
</script>

<style lang="scss" scoped>
.icon-box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 54px;
  margin-top: 54px;

  .hoverable-icon-big {
    margin-bottom: 32px;
  }

  .hoverable-icon-big:focus-visible {
    outline: 2px solid var(--primary-color-0);
    outline-offset: 5px;
    border-radius: 5px;
  }
}
</style>
